import { useEffect, useState } from 'react'

import { useSearchBy } from '@/shared/hooks/useSearchBy'
import { ChannelType } from '@/shared/types/appTypes'

const useFilteredBySearchChannels = (
    channels: ChannelType[],
    searchValue: string
) => {
    const [finallyFiltered, setFinallyFiltered] = useState(channels)
    const { filteredArray } = useSearchBy(channels, searchValue)

    useEffect(() => {
        setFinallyFiltered(searchValue.length ? filteredArray : channels)
    }, [filteredArray, channels])

    return { finallyFiltered }
}

export default useFilteredBySearchChannels
